import React from 'react';
import ArticleCard from '../components/ArticleCard';
import { useArticles } from '../context/ArticlesContext';
import MainLayout from '../layouts/MainLayout';

const ArticlesPage: React.FC = () => {
  const { articles, loading, error } = useArticles();

  return (
    <MainLayout>
      <div className="atlas-page">
        <div className="atlas-page-heading">
          <span className="atlas-kicker">БАЗА ЗНАНИЙ</span>
          <h1>Статьи и заметки<span className="atlas-punctuation">.</span></h1>
          <p>Практические материалы из ежедневной работы с разработкой, 1С и DevOps.</p>
        </div>
        {loading ? (
          <div className="atlas-loading" aria-live="polite">Загрузка материалов…</div>
        ) : error ? (
          <div className="atlas-notice" role="status">{error}</div>
        ) : articles.length ? (
          <div className="atlas-page-records">{articles.map((article, index) => <ArticleCard key={article.id} article={article} featured={index === 0} />)}</div>
        ) : (
          <div className="atlas-notice">Нет статей для отображения.</div>
        )}
      </div>
    </MainLayout>
  );
};

export default ArticlesPage;
